// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__22Z1J","title":"Info_title__1_Wn3","links":"Info_links__A3aGO","link":"Info_link__2TlnY","logo":"Info_logo__1otRE"};